import clsx from "clsx";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import { Controller, FieldValues, useForm } from "react-hook-form";
import { useAuthContext } from "../../../../context/AuthContext";
import { useToast } from "../../../../context/toast/ui";
import { ResursTreeApi } from "../../../../services/modules/tree";
import styles from "./quick-create-user.module.css";

export const QuickCreateModalUser = (props: {
  show: boolean;
  setShow: (value: boolean) => void;
  tree: ResursTreeApi.treeName;
}) => {
  const { show, setShow } = props;

  const { control, handleSubmit } = useForm();

  const handleRadioChange = (value: string) => {
    //setIsDisabled(value === 'simple');
  };
  const { userRole } = useAuthContext();
  const { showMessage } = useToast();

  const onSubmit = (data: FieldValues) => {
    if (userRole === "usr") {
      showMessage({
        caption: "Ошибка",
        message: "У вас нет прав!",
        tag: "add",
        timeOut: 3,
        type: "error",
      });

      return;
    }

    if ((data["home"] as number) === 0) {
      showMessage({
        caption: "Внимание!",
        message: "Количество домов должно быть больше нуля!",
        tag: "quick",
        timeOut: 3,
        type: "warn",
      });

      return;
    }
    setShow(false);
    ResursTreeApi.createUserTree({
      options: {
        mc: data["mc"] as number,
        home: data["home"] as number,
        entrance: data["entrance"] as number,
        flat: data["flat"] as number,
        userType: data["userType"] as string,
        userCount: data["userCount"] as number,
        userAccount: data["userAccount"] as number,
      },
    });
  };

  return (
    <Dialog
      dismissableMask
      header="Создание дерева абонентов"
      style={{ width: 460 }}
      visible={show}
      onHide={() => {
        setShow(false);
      }}
    >
      <form
        data-at-wc-quick-create-modal-form
        onSubmit={handleSubmit(onSubmit)}
        className={styles.form}
      >
        <div className={styles.description}>
          Давайте быстро и просто создадим дерево абонентов. Укажите необходимые
          параметры и нажмите «Создать».
        </div>
        <Controller
          name="mc"
          control={control}
          defaultValue={0}
          render={({ field }) => (
            <div className={"p-inputgroup flex-1"}>
              <span
                className={clsx(
                  "p-inputgroup-addon",
                  styles.resurs__props__field_label
                )}
                style={{
                  cursor: "default",
                }}
              >
                Управляющих компаний:
              </span>

              <InputText
                data-at-wc-quick-create-modal-count-uk
                id={field.name}
                value={field.value}
                onBlur={field.onBlur}
                onChange={field.onChange}
                min={0}
                maxLength={2}
                className={styles.inputText}
                max={99}
              />
            </div>
          )}
        />

        <Controller
          name="home"
          control={control}
          defaultValue={1}
          render={({ field }) => (
            <div className={"p-inputgroup flex-1"}>
              <span
                className={clsx(
                  "p-inputgroup-addon",
                  styles.resurs__props__field_label
                )}
                style={{
                  cursor: "default",
                }}
              >
                Домов:
              </span>

              <InputText
                data-at-wc-quick-create-modal-count-house
                id={field.name}
                value={field.value}
                onBlur={field.onBlur}
                onChange={field.onChange}
                min={0}
                maxLength={2}
                className={styles.inputText}
                max={99}
              />
            </div>
          )}
        />

        <Controller
          name="entrance"
          control={control}
          defaultValue={0}
          render={({ field }) => (
            <div className={"p-inputgroup flex-1"}>
              <span
                className={clsx(
                  "p-inputgroup-addon",
                  styles.resurs__props__field_label
                )}
                style={{
                  cursor: "default",
                }}
              >
                Подъездов в доме:
              </span>

              <InputText
                data-at-wc-quick-create-modal-count-entrance
                id={field.name}
                value={field.value}
                onBlur={field.onBlur}
                onChange={field.onChange}
                min={0}
                maxLength={2}
                className={styles.inputText}
                max={99}
              />
            </div>
          )}
        />
        <Controller
          name="flat"
          control={control}
          defaultValue={1}
          render={({ field }) => (
            <div className={"p-inputgroup flex-1"}>
              <span
                className={clsx(
                  "p-inputgroup-addon",
                  styles.resurs__props__field_label
                )}
                style={{
                  cursor: "default",
                }}
              >
                Квартир в подъезде:
              </span>

              <InputText
                data-at-wc-quick-create-modal-count-entrance-apartament
                id={field.name}
                value={field.value}
                onBlur={field.onBlur}
                onChange={field.onChange}
                min={0}
                maxLength={3}
                max={999}
                className={styles.inputText}
              />
            </div>
          )}
        />
        <Controller
          name="userType"
          defaultValue={"simple"}
          control={control}
          render={({ field }) => (
            <div className={styles.radioGroup}>
              <label className={styles.radioGroupLabel}>
                Тип счета в квартире:
              </label>

              <div className={styles.radioOptions}>
                <div className={styles.radioOption}>
                  <RadioButton
                    inputId="f5"
                    {...field}
                    data-at-wc-quick-create-modal-simple-user-radio
                    inputRef={field.ref}
                    value="simple"
                    onChange={(e) => {
                      field.onChange(e);
                      handleRadioChange(e.value);
                    }}
                    checked={field.value === "simple"}
                  />
                  <label htmlFor="f5">Единый счёт</label>
                </div>

                <div className={styles.radioOption}>
                  <RadioButton
                    inputId="f6"
                    {...field}
                    value="host"
                    data-at-wc-quick-create-modal-multy-user-radio
                    checked={field.value === "host"}
                    onChange={(e) => {
                      field.onChange(e);
                      handleRadioChange(e.value);
                    }}
                  />
                  <label htmlFor="f6">Мульти счёт</label>
                </div>
              </div>
            </div>
          )}
        />
        <Controller
          name="userCount"
          control={control}
          defaultValue={1}
          render={({ field }) => (
            <div className={"p-inputgroup flex-1"}>
              <span
                className={clsx(
                  "p-inputgroup-addon",
                  styles.resurs__props__field_label
                )}
                style={{
                  cursor: "default",
                }}
              >
                Абонентов в квартире:
              </span>

              <InputText
                data-at-wc-quick-create-modal-user-count-input
                id={field.name}
                value={field.value}
                onBlur={field.onBlur}
                onChange={field.onChange}
                min={0}
                max={9}
                maxLength={1}
                className={styles.inputText}
              />
            </div>
          )}
        />
        <Controller
          name="userAccount"
          control={control}
          defaultValue={3}
          render={({ field }) => (
            <div className={"p-inputgroup flex-1"}>
              <span
                className={clsx(
                  "p-inputgroup-addon",
                  styles.resurs__props__field_label
                )}
                style={{
                  cursor: "default",
                }}
              >
                Счетов на абонента:
              </span>

              <InputText
                data-at-wc-quick-create-modal-user-check-count-input
                id={field.name}
                value={field.value}
                onBlur={field.onBlur}
                onChange={field.onChange}
                min={0}
                max={9}
                maxLength={1}
                className={styles.inputText}
              />
            </div>
          )}
        />

        <Button
          label="Создать"
          size="small"
          data-at-wc-quick-create-modal-submit
        />
      </form>
    </Dialog>
  );
};
